import {address, maps} from "../data/data";
import {useState} from "react";
import ic_phone from "../assets/icon/ic_phone.svg";
import ic_mail from "../assets/icon/ic_mail.svg";
import ic_office from "../assets/icon/ic_office.svg";
import {useTranslation} from "react-i18next";

export const Address = () => {
    const {t} = useTranslation();
    const [map, setMap] = useState(address[0].image)

    const onNavigate = (link) => {
        window.open(link, "_blank");
    }

    return (
        <div className="flex flex-row max-lg:flex-col gap-8 place-content-center max-w-screen-xl">
            <img src={maps[t(map)]} alt="Company Map" className="w-4/6 max-lg:w-full rounded-2xl drop-shadow-xl object-cover"/>
            <div className="flex flex-col items-start bg-white rounded-2xl w-2/6 max-lg:w-full px-6 py-4">
                <h2 className="font-bold text-xl mb-4">{t("navigation_menu_contact")}</h2>
                {address.map((item, index) => (
                    <div key={index}
                         className="text-start flex flex-col gap-0.5 items-start"
                         onMouseOver={() => setMap(address[index].image)}>
                        <div
                            className={`bg-line-color h-0.5 min-w-full ${index > 0 ? "visible my-4" : "invisible"}`}></div>
                        <p className="text-secondary-color font-bold text-base mb-2">{t(item.name)}</p>
                        <p className="text-sm text-left mb-1">{t(item.description)}</p>
                        <ContactLabel key={index + item.number} icon={ic_phone} name={item.number} fontSize="text-sm"/>
                        <ContactLabel key={index + item.mail} icon={ic_mail} name={item.mail} fontSize="text-sm"/>
                        <ContactLabel key={index + item.time} icon={ic_office} name={t(item.time)} fontSize="text-sm"/>
                        <button onClick={() => onNavigate(item.map_link)}
                                className="bg-primary text-white text-sm font-bold py-0.5 px-3 rounded mt-3">
                            Google map
                        </button>
                    </div>
                ))}
            </div>
        </div>
    )
}

export const ContactLabel = (props) => {
    return (
        <div className="flex flex-row space-x-2">
            <img src={props.icon} alt={props.name} className="w-5 p-1 aspect-square bg-green rounded-full"/>
            <p className={`${props.fontSize} text-left`}>{props.name}</p>
        </div>
    );
}